import {createAsyncThunk} from '@reduxjs/toolkit';
import {CLDispatch, RootState} from 'common/src/redux/store';
import {updateBrandGuidelines, updateLocalBrandGuidelines, setLoading, setError} from '../brandGuidelines.slice';
import brandGuidelinesApi from 'common/src/modules/brandGuidelines/brandGuidelines.api';
import {BrandGuidelines} from 'common/src/modules/brandGuidelines/brandGuidelines.types';

export const loadBrandGuidelines = createAsyncThunk<
  BrandGuidelines,
  void,
  {dispatch: CLDispatch; state: RootState}
>(
  'brandGuidelines/load',
  async (_, {dispatch, rejectWithValue}) => {
    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
      // The API uses the authenticated user's context, so we don't need to pass clientId
      const brandGuidelines = await brandGuidelinesApi.getBrandGuidelines(); 

      dispatch(updateBrandGuidelines(brandGuidelines));
      // Initialize local state with the loaded data
      dispatch(updateLocalBrandGuidelines(brandGuidelines));
      
      return brandGuidelines;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to fetch brand guidelines';
      dispatch(setError(errorMessage));

      return rejectWithValue(errorMessage);
    } finally {
      dispatch(setLoading(false));
    }
  },
); 